// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
// views
import { nothing } from '$func/utils'
import { sendAnalytics, sendAnalyticsImmediately } from '$logic/analytics'
import { dateWithOffset } from '$logic/client-device/time-offset.service'

window.analiteWithRetry = nothing

window.analite = (type, data, persist = false, timestamp?: number) => {
  sendAnalytics({
    type,
    ts: new Date(timestamp || dateWithOffset()),
    ...(data && { payload: data }),
    persist,
  })
}

window.analiteImmediatly = (type, data, persist = false, timestamp?: number) => {
  sendAnalyticsImmediately({
    type,
    ts: new Date(timestamp || dateWithOffset()),
    ...(data && { payload: data }),
    persist,
  })
}

declare global {
  // eslint-disable-next-line no-var,vars-on-top
  let analite: (
    type: string,
    data?: Record<string, unknown>,
    persist?: boolean,
    timestamp?: number,
  ) => void
}
